export default __webpack_public_path__ + "static/media/liberum-10.481c21ed.png";